import type { ExcalidrawFontFaceDescriptor } from "../Fonts";

// Using Google Fonts CDN for Source Sans Pro
export const SourceSansProFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: "https://fonts.gstatic.com/s/sourcesanspro/v22/6xK3dSBYKcSV-LCoeQqfX1RYOo3qOK7lujVj9w.woff2",
    descriptors: { style: "normal", weight: "400" },
  },
  {
    uri: "https://fonts.gstatic.com/s/sourcesanspro/v22/6xK3dSBYKcSV-LCoeQqfX1RYOo3qN67lujVj9w.woff2",
    descriptors: { style: "normal", weight: "600" },
  },
  {
    uri: "https://fonts.gstatic.com/s/sourcesanspro/v22/6xK3dSBYKcSV-LCoeQqfX1RYOo3qPK7lujVj9w.woff2",
    descriptors: { style: "normal", weight: "700" },
  },
  {
    uri: "https://fonts.gstatic.com/s/sourcesanspro/v22/6xK1dSBYKcSV-LCoeQqfX1RYOo3qPZYokp1XvQ.woff2",
    descriptors: { style: "italic", weight: "400" },
  },
];